<script lang="ts">
    import { onDestroy, onMount } from 'svelte';
    import { get } from 'svelte/store';
    import { Link } from 'svelte-routing';
    import Auth from '../Auth/Auth';
    import { userInfo } from '../../store.svelte';

    let dropDownOpen = $state(false);
    const googleUserInfo: userInfoInterface = get(userInfo);

    function handleOutsideClick() {
        dropDownOpen = false;
    }

    onMount(() => window.addEventListener('click', handleOutsideClick));
    onDestroy(() => window.removeEventListener('click', handleOutsideClick));
</script>

<div class="menu position-relative" style="min-width: 100px;">
    <div class="dropdown">
        <button
            class="btn bg-transparent w-100 text-start dropdown-toggle"
            type="button"
            onclick={(e) => { dropDownOpen = !dropDownOpen; e.stopPropagation(); }}
        >
            <img src={googleUserInfo?.picture} alt="Аватар" class="rounded-circle" width="30" height="30" />
        </button>
    </div>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" class:d-block={dropDownOpen}>
        <Link class="dropdown-item" to="/">Головна</Link>
        <Link class="dropdown-item" to="/user">Профіль</Link>
        <a class="dropdown-item" href="#" onclick={(e) => { e.preventDefault(); Auth.logout(); }}>Вийти</a>
    </div>
</div>

<style>
    button:focus, button:active {
        outline: none;
        border: none;
    }
</style>
